import { AxiosError } from "axios";
import { getParticipantExternalSystem } from "../services/QBO/QBOServices";
import * as constants from "../../../constants";

export async function getParticipantExternalSystemDetails(
    participantId: number,
    clientId: number,
    name: string
): Promise<string | undefined> { 
    try {
        const responseList = await getParticipantExternalSystem(participantId, clientId, name); 
        if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
            const isEnabled = responseList.data.data.isEnabled;  
            return isEnabled ?? "N";
        }
       return "N"; 
    } catch (error) {
        if (error instanceof AxiosError) {
            console.error('axiosError', error.response?.data ?? error.message);
        } else {
            console.error('unexpectedError', error);
        }
        return "N";
    }
}
